import { useEffect, useState } from 'react';
import { getAllInvoiceGroups } from 'src/shared/services/invoiceGroupService';
import { getAllPayments } from 'src/shared/services/paymentService';

/** Returns the total number of unaccounted payments across all invoice groups */
export const useUnaccountedPaymentsBadge = () => {
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    getAllInvoiceGroups(0, 500, 'name', 'asc', '')
      .then(async (groupsRes) => {
        const groups = groupsRes.data.results;
        if (!groups.length) return;

        const counts = await Promise.all(
          groups.map((group) =>
            getAllPayments({
              pageIndex: 0,
              pageSize: 1,
              sortCol: 'date',
              sortDir: 'desc',
              filter: '',
              ownerId: group.owner_id,
              unaccountedOnly: true,
            })
              .then((res) => res.data.totalItems)
              .catch(() => 0),
          ),
        );

        setTotalCount(counts.reduce((sum, c) => sum + c, 0));
      })
      .catch(() => undefined);
  }, []);

  return totalCount;
};
